import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ebookImg from '../../assets/home/book2.jpg';

const ResourcesHero = () => {
  const navigate = useNavigate();

  const handleExploreLibrary = () => {
    const librarySection = document.getElementById('library-section');

    if (librarySection) {
      librarySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="w-full py-12 md:py-20 px-6 font-inter bg-transparent">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 border border-blue-100 mb-6">
              <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" />
              <span className="text-[11px] font-black uppercase tracking-wider text-blue-600">
                Centre de ressources
              </span>
            </div>

            <h1 className="text-[#0f172a] text-4xl md:text-5xl font-black mb-6 tracking-tight leading-[1.1]">
              Ressources <span className="text-[#1e3a5f]">Nodixs</span>
            </h1>

            <p className="text-slate-500 text-base md:text-lg font-medium max-w-xl mb-10 leading-relaxed">
              Developpez vos connaissances avec nos guides et ebooks exclusifs.
              Accedez a notre bibliotheque de contenus experts pour optimiser vos processus.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <button
                onClick={handleExploreLibrary}
                className="w-full sm:w-auto bg-[#1e3a5f] text-white px-8 py-4 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-[#0f172a] hover:shadow-xl hover:shadow-blue-900/20 active:scale-95 transition-all duration-300 group"
              >
                Explorer la bibliotheque
                <BookOpen size={18} className="group-hover:rotate-12 transition-transform" />
              </button>

              <button
                onClick={() => navigate('/rdv')}
                className="w-full sm:w-auto bg-white border border-slate-200 text-slate-700 px-8 py-4 rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-slate-50 hover:text-[#1e3a5f] hover:border-blue-200 active:scale-95 transition-all duration-300"
              >
                Prendre rendez-vous
                <Calendar size={18} />
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative flex justify-center lg:justify-end"
          >
            <motion.div
              animate={{ y: [0, -8, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
              className="relative"
            >
              <div className="relative overflow-hidden rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] border-4 border-white max-h-[420px]">
                <img
                  src={ebookImg}
                  alt="Ebook Nodixs"
                  className="w-full max-w-[360px] h-full object-cover object-top"
                />
              </div>

              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-blue-500/10 blur-3xl -z-10" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ResourcesHero;
